import React, { useContext } from "react";
import LanguageContext from "context/context-language";
import { Col, Row } from "reactstrap";
import "assets/css/clientes.css";

function Clientes() {
    const { language, handleLanguage } = useContext(LanguageContext);

    const clientes1 = {
        cfe: require("assets/img/clientes/cfe.png"),
        imbera: require("assets/img/clientes/imbera.png"),
        hsbc: require("assets/img/clientes/hsbc.png"),
        bancoppel: require("assets/img/clientes/bancoppel.png"),

    }

    const clientes2 = {
        wis: require("assets/img/clientes/wis.png"),
        philips: require("assets/img/clientes/philips.png"),
        whitern: require("assets/img/clientes/wittern.png"),
    }


    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                height: "100%",
                padding: "0 120px 0 120px",                
            }}
        >
            <br />
            <div className="tituloCasosExito">{language === 'es' ? "Nuestros Clientes" : "Our Clients"}</div>
            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: '80%',
                    display: "flex",
                    justifyContent: "center",
                    alignItems: 'center',                    
                }}
                
            >
                <div
                    style={{
                        width: '100%'
                    }}
                >
                    <Row>
                        {
                            Object.keys(clientes1).map((item, index) => {
                                return <Col lg={3} md={4} sm={6} xs={12}>
                                    <div
                                        className="backgroundCliente"
                                        style={{                                            
                                            backgroundImage: `url(${clientes1[item]})`,
                                        }}
                                    >                                        
                                    </div>
                                </Col>
                            })
                        }
                    </Row>
                    <br/>
                    <Row>
                        {
                            Object.keys(clientes2).map(item => {
                                return <Col lg={4} md={3} sm={6} xs={12}>
                                    <div
                                        className="backgroundCliente"
                                        style={{                                            
                                            backgroundImage: `url(${clientes2[item]})`,
                                        }}
                                    >
                                        
                                    </div>
                                </Col>
                            })
                        }
                    </Row>
                </div>                
            </div>
            <br/>
            <br/>
            <br/>
            <div
                style={{
                    borderBottom: "solid 1px #D9D9D9"
                }}
            ></div>

        </div>
    )
}

export default Clientes;